export { default } from "./Story.vue";
